import { gql, useMutation } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

/**
 * Admin-Override: re-runs a finished service check with the relevance
 * classifier skipped, so the service is added to the originally chosen
 * category regardless of the previous verdict. Server-side restricted to
 * platform admins (`User.isAdmin`).
 */
const FORCE_SERVICE_CHECK = gql`
  mutation ForceServiceCheck($id: ID!, $token: String) {
    forceServiceCheck(id: $id, token: $token) {
      id
      status
      verdict
      forcedAt
    }
  }
`;

export interface ForceServiceCheckVariables {
  id: string;
  token?: string | null;
}

export interface ForceServiceCheckData {
  forceServiceCheck: {
    id: string;
    status: 'PENDING' | 'COMPLETED' | 'FAILED';
    verdict: 'RELEVANT_ADDED' | 'NOT_RELEVANT' | 'WRONG_CATEGORY' | 'DUPLICATE' | null;
    forcedAt: string | null;
  };
}

export function useForceServiceCheckMutation() {
  const { token } = useShareTokenJwt();
  const [mutate, result] = useMutation<ForceServiceCheckData, ForceServiceCheckVariables>(FORCE_SERVICE_CHECK);
  const wrapped: typeof mutate = (options) =>
    mutate({ ...options, variables: { ...(options?.variables as ForceServiceCheckVariables), token } });
  return [wrapped, result] as const;
}
